import { cn } from "@/lib/utils";
import { Lock } from "lucide-react";
import { STATUS_META } from "@/lib/workflow";

export function StatusBadge({ status, locked, className }) {
  const s = (status || "draft").toLowerCase();
  const meta = STATUS_META[s] || STATUS_META.draft;
  return (
    <span
      data-testid={`status-badge-${s}`}
      className={cn(
        "inline-flex items-center gap-1 font-mono text-[11px] px-2.5 py-0.5 rounded-full font-semibold uppercase tracking-wider border whitespace-nowrap",
        meta.badge,
        className
      )}
    >
      {locked && <Lock className="w-3 h-3" />}
      {meta.label}
    </span>
  );
}
